'use client';

import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import Spinner from '@/common/components/spinner/spinner.component';

interface SearchLoadingOverlayProps {
  message?: string;
}

export function SearchLoadingOverlay({
  message = 'در حال جستجو...',
}: SearchLoadingOverlayProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  if (!mounted) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[90] flex flex-col items-center justify-center gap-4 bg-white"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
    >
      <Spinner
        containerClassName="!w-auto !h-auto"
        spinnerClassName="!h-12 !w-12 !text-plp-accent"
      />
      <p className="text-sm font-medium text-plp-secondary">{message}</p>
    </div>,
    document.body
  );
}
